import * as z from "zod";
//#region src/__generated__/auth/group/zod/groupDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const groupDtoSchema = z.object({
	attributes: z.object({}).catchall(z.array(z.string())).nullish(),
	id: z.uuid().nullish(),
	name: z.string().nullish()
});
//#endregion
//#region src/__generated__/auth/group/zod/getAllGroupsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getAllGroupsQueryBriefRepresentationSchema = z.boolean().optional();
const getAllGroupsStatus200Schema = z.array(groupDtoSchema);
const getAllGroupsResponseSchema = getAllGroupsStatus200Schema;
//#endregion
//#region src/__generated__/auth/group/zod/getGroupByIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getGroupByIdPathGroupIdSchema = z.uuid();
const getGroupByIdStatus200Schema = groupDtoSchema;
const getGroupByIdResponseSchema = getGroupByIdStatus200Schema;
//#endregion
//#region src/__generated__/auth/group/zod/userGroupDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const userGroupDtoSchema = z.object({
	id: z.uuid().nullish(),
	name: z.string().nullish()
});
//#endregion
//#region src/__generated__/auth/group/zod/getUserGroupsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUserGroupsPathUserIdSchema = z.uuid();
const getUserGroupsStatus200Schema = z.array(userGroupDtoSchema);
const getUserGroupsResponseSchema = getUserGroupsStatus200Schema;
//#endregion
//#region src/__generated__/auth/group/zod/userDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const userDtoSchema = z.object({
	attributes: z.object({}).catchall(z.array(z.string())).nullish(),
	email: z.string().nullish(),
	enabled: z.boolean().nullish(),
	firstName: z.string().nullish(),
	groups: z.array(groupDtoSchema).nullish(),
	id: z.uuid().nullish(),
	lastName: z.string().nullish(),
	middleName: z.string().nullish(),
	passwordValidTo: z.string().nullish(),
	phone: z.string().nullish(),
	position: z.string().nullish(),
	realmRoles: z.array(z.string()).nullish(),
	userValidTo: z.string().nullish()
});
//#endregion
//#region src/__generated__/auth/group/zod/getUsersByGroupSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUsersByGroupPathGroupIdSchema = z.uuid();
const getUsersByGroupStatus200Schema = z.array(userDtoSchema);
const getUsersByGroupResponseSchema = getUsersByGroupStatus200Schema;
//#endregion
//#region src/__generated__/auth/group/zod/getUsersByGroupWithRoleSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUsersByGroupWithRolePathGroupIdSchema = z.uuid();
const getUsersByGroupWithRoleQueryUserRoleSchema = z.string();
const getUsersByGroupWithRoleStatus200Schema = z.array(userDtoSchema);
const getUsersByGroupWithRoleResponseSchema = getUsersByGroupWithRoleStatus200Schema;
//#endregion
//#region src/__generated__/auth/group/zod/getUsersPaginated1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUsersPaginated1QueryParamSchema = z.string().optional().describe("Отвечает за выборку по названию организации. При необходимости получения последовательно всего списка организаций параметр следует игнорировать.");
const getUsersPaginated1QueryFirstSchema = z.string().optional().describe("Позиция начала результатов выборки.");
const getUsersPaginated1QueryMaxSchema = z.string().optional().describe("Общее колличество возвращаемых данных из выборки.");
const getUsersPaginated1QueryFullRepresentationSchema = z.boolean().optional().describe("Отвечает за представление группы в полном(с атрибутами, ролями и т.п.) или сокращенном(без атрибутов и т.п.) виде.");
const getUsersPaginated1Status200Schema = z.array(groupDtoSchema);
const getUsersPaginated1ResponseSchema = getUsersPaginated1Status200Schema;
//#endregion
export { getAllGroupsResponseSchema as C, getAllGroupsQueryBriefRepresentationSchema as S, groupDtoSchema as T, getUserGroupsStatus200Schema as _, getUsersPaginated1ResponseSchema as a, getGroupByIdResponseSchema as b, getUsersByGroupWithRoleQueryUserRoleSchema as c, getUsersByGroupPathGroupIdSchema as d, getUsersByGroupResponseSchema as f, getUserGroupsResponseSchema as g, getUserGroupsPathUserIdSchema as h, getUsersPaginated1QueryParamSchema as i, getUsersByGroupWithRoleResponseSchema as l, userDtoSchema as m, getUsersPaginated1QueryFullRepresentationSchema as n, getUsersPaginated1Status200Schema as o, getUsersByGroupStatus200Schema as p, getUsersPaginated1QueryMaxSchema as r, getUsersByGroupWithRolePathGroupIdSchema as s, getUsersPaginated1QueryFirstSchema as t, getUsersByGroupWithRoleStatus200Schema as u, userGroupDtoSchema as v, getAllGroupsStatus200Schema as w, getGroupByIdStatus200Schema as x, getGroupByIdPathGroupIdSchema as y };

//# sourceMappingURL=getUsersPaginated1Schema.js.map